import { solutionModelModule } from '../../models/solution';
import { getUserId } from '../../utils/account-utils/account-utils';

export const solutionAutosaveHelperModule = angular
  .module('Q.helpers.solution-autosave-helper', [solutionModelModule])

  .factory('solutionAutosaveHelper', function ($q, Solution, $injector) {
    /**
     * Handles an automatic save of a solution
     * @param {string?} tag - Optional tag for this save
     * @param {formDataService?} fd - FormDataService if available (required for saving)
     * @param {Team} team - User team model
     * @param {Solution} solution - Original solution model
     * @param {*?} cursor - Cursor data
     * @param {interactService?} interact - Interact service
     * @return {Promise|boolean} - Promise of save attempt, or false if no changes or unsaved for other reasons
     */
    function solutionAutosaveHelper({
      tag = 'autosave',
      fd,
      team,
      solution,
      cursor,
      interact,
    }) {
      // ignore autosave events if we don't have any changes
      if (fd && solution && (fd.hasChanges() || tag !== 'autosave')) {
        let changes = fd.getChanges();
        if (team) {
          changes = Object.assign({}, changes, {
            ipTracking: team.hasFeature('ipTracking'),
          });
        }

        // Ignore file/code changes when being edited by others (even if they aren't currently editing)
        if (interact && !interact.isUserActiveEditor) {
          delete changes.files;
          delete changes.code;
          delete changes.testCases;
          if (!Object.keys(changes).length) {
            // no remaining changes, so just return
            return false;
          }
          // ignore cursor updates, too
          cursor = undefined;
        }

        if (solution.expired()) {
          // only allow candidate notes if the solution is expired
          if (!changes.candidateNotes) {
            return false;
          }
          changes = {
            candidateNotes: changes.candidateNotes,
            lastEditedById: getUserId($injector),
          };
        } else {
          // track additional data as needed
          changes.tag = tag;
          changes.event = tag && tag !== 'autosubmit';
          changes.cursor = cursor;
          changes.lastEditedById = getUserId($injector);
        }

        if (changes.files && changes.cursor) {
          // Also store cursor on the correct file for advanced code
          const f = changes.files.find((f) => f.path === changes.cursor.path);
          if (f) {
            f.cursor = changes.cursor;
          }
        }

        if (interact) {
          interact.markSaving();
        }

        return Solution.saveOrCreate(solution, changes, {
          ignoreLoadingBar: true,
        }).then((resp) => {
          if (interact) {
            // TODO: what happens if the save fails?
            interact.markSaved();
          }
          return resp;
        });
      } else {
        return false;
      }
    }

    return solutionAutosaveHelper;
  });
